// Event names should have the following format <DOMAIN>(_FEATURE)_<ACTION>
// FEATURE can be optional
// ex: <ADDITIONAL_SERVICES>(_CONTAINS_ALCOHOL)_<TOGGLE>

// Carrier Account Related Events
export const CARRIER_REGISTRATION_SUCCESS = 'CARRIER_REGISTRATION_SUCCESS';

export const EBAYCA_PRIMARY_BUTTON = 'EBAYCA_PRIMARY_BUTTON';
